(() => {
  if (customElements.get('wholesale-reorder')) return;
  class WholesaleReorder extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-reorder-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-reorder-panel]'));
      if (this.tabs.length !== 2 || this.panels.length !== 2) return;
      this.querySelector('[data-reorder-tabs]').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[i].id);
        this.panels[i].setAttribute('role', 'tabpanel');
        tab.addEventListener('click', event => { event.preventDefault(); this.select(i); }, options);
        tab.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); this.select(i); return; }
          const keys = { ArrowRight: (i + 1) % 2, ArrowLeft: (i + 1) % 2, Home: 0, End: 1 };
          if (!(event.key in keys)) return;
          event.preventDefault();
          this.select(keys[event.key]);
          this.tabs[keys[event.key]].focus();
        }, options);
      });
      const linkedPanel = this.panels.findIndex(panel => '#' + panel.id === location.hash);
      this.select(linkedPanel < 0 ? 0 : linkedPanel);
      if (location.hash === '#reorder') this.querySelector('#reorder')?.focus({ preventScroll: true });
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#reorder') return;
        const workspace = this.querySelector('#reorder');
        if (!workspace) return;
        event.preventDefault();
        const drawer = document.getElementById('mini-cart');
        if (drawer?.hasAttribute('open')) {
          // Use the existing drawer trap without returning focus to its old opener.
          drawer.focusTrap?.deactivate({ returnFocus: false });
          drawer.querySelector('button[data-action="close"]')?.click();
        }
        history.replaceState(history.state, '', location.pathname + location.search + '#reorder');
        workspace.focus({ preventScroll: true });
        workspace.scrollIntoView({ behavior: 'auto', block: 'start' });
      }, options);
      const invalidateSummary = event => {
        const summary = this.querySelector('[data-reorder-cart-summary]');
        if (summary) summary.hidden = true;
        const count = event?.detail?.cart?.item_count;
        const continueLink = this.querySelector('[data-reorder-continue]');
        const startLink = this.querySelector('[data-reorder-start]');
        if (continueLink && startLink && Number.isInteger(count) && count >= 0) {
          continueLink.hidden = count === 0;
          startLink.hidden = count > 0;
        }
      };
      document.addEventListener('cart:updated', invalidateSummary, options);
      document.addEventListener('cart:refresh', invalidateSummary, options);
      window.addEventListener('pageshow', event => { if (event.persisted) invalidateSummary(); }, options);
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('wholesale-reorder', WholesaleReorder);
})();
